import { useState } from "react";

function StartScreen({ setGameStarted }) {
  return (
    <>
      <h1>Reaksjonsspill</h1>
      <p>Klikk på de riktige figurene!</p>
      <button onClick={() => setGameStarted(true)}>Start spill</button>
    </>
  );
}

export default StartScreen;
